import { SellerRoleEnum } from 'v3/data/store/seller/enum';
import { ISellerState } from 'v3/data/store/seller/types';

export const sellerInitialState: ISellerState = {
  seller: {
    id: '',
    active: true,
    name: '',
    code: '',
    role: SellerRoleEnum.Seller,
    storeId: '',
    profileId: '',
    store: {
      id: '',
      name: '',
    },
  },
  sellerList: {
    count: 0,
    sellersList: [],
  },
  sellersFilter: {
    filter: '',
    active: null,
    page: 0,
    rowsPerPage: 20,
    storeIds: [],
  },
  storeList: [
    {
      id: '',
      name: '',
      cnpj: '',
      address: {
        city: '',
        state: '',
        street: '',
        number: '',
        neighborhood: '',
        postalCode: '',
      },
    },
  ],
  uploadSellerFileResponse: {
    data: {
      message: '',
      validRowsCount: 0,
      totalRows: 0,
      invalidRowsCount: 0,
      invalidRows: [{ data: [], line: 0 }],
    },
    sellerInvalidRowsModalOpen: false,
  },
};
